import { Switch } from "~components";
import { Css } from "~generated/css";
import { useTestIds } from "~utils";

type ExpiredOptionsSwitchProps = {
  showExpiredOptions: boolean;
  setShowExpiredOptions: (showExpiredOptions: boolean) => void;
};

export function ExpiredOptionsSwitch(props: ExpiredOptionsSwitchProps) {
  const { showExpiredOptions, setShowExpiredOptions } = props;
  const switchTid = useTestIds(props, "expiredOptionsSwitch");
  return (
    <div css={Css.df.gap1.asStretch.aic.$}>
      <div css={Css.t12.gray.$}>Show expired options</div>
      <Switch value={showExpiredOptions} onClick={() => setShowExpiredOptions(!showExpiredOptions)} {...switchTid} />
    </div>
  );
}
